export const CATEGORY_IMAGES_PATH = process.env.REACT_APP_CATEGORY_IMAGES_PATH ?? '';
export const PRODUCTS_CATEGORY_IMAGES_PATH =
    process.env.REACT_APP_PRODUCTS_CATEGORY_IMAGES_PATH ?? '';
